import axios from '@/libs/api.request'

/**
 * 调查问卷管理（问卷调查 + 用工调查）
 */

// 问卷列表
export const getSurveyList = (page = 1, limit = 20, params = {}) => {
  return axios.request({
    url: '/v2/survey/mg/list',
    method: 'get',
    params: {
      page,
      limit,
      key: params.key,
      type: params.type,
      status: params.status
    }
  })
}

// 问卷详情
export const getSurveyDetail = (id) => {
  return axios.request({
    url: `/v2/survey/mg/detail/${id}`,
    method: 'get'
  })
}

// 保存问卷（新建/编辑）
export const saveSurvey = (data) => {
  return axios.request({
    url: '/v2/survey/mg/save',
    method: 'post',
    data
  })
}

// 删除问卷（软删）
export const deleteSurvey = (id) => {
  return axios.request({
    url: '/v2/survey/mg/delete',
    method: 'post',
    data: { id }
  })
}

// 发布问卷
export const publishSurvey = (id) => {
  return axios.request({
    url: '/v2/survey/mg/publish',
    method: 'post',
    data: { id }
  })
}

// 用工调查汇总数据
export const getSurveyJobdata = (surveyId) => {
  return axios.request({
    url: '/v2/survey/mg/jobdata',
    method: 'get',
    params: { survey_id: surveyId }
  })
}